import React from "react";
import { useUpsertReviewMutation } from "../../../api/reviewApi";
import { getDeviceId } from "../../../utils/deviceId";
import { Review } from "../../../interfaces/entities/review";
import { DefaultReview } from "../../../defaultValues/defaultReview";
import { EmployeeReview } from "./employeeReview";
import { useToast } from "../../../hooks/useToast";
import { useLoader } from "../../../hooks/useLoader";
import { useGetCompanyByIdQuery } from "../../../api/companyApi";
import { LoadingIndicator } from "../../shared/alerts/loadingIndicator";

interface ReviewContainerProps {
  userId: string;
  employeeName?: string;
  employeeImage?: string;
  branchId: string;
  companyId: string;
  openDialog?: boolean;
  onDialogClose?: () => void;
}

export const ReviewContainer: React.FC<ReviewContainerProps> = ({
  userId,
  employeeName,
  employeeImage,
  branchId,
  companyId,
  openDialog,
  onDialogClose,
}) => {
  const [upsertReview] = useUpsertReviewMutation();
  const deviceId = getDeviceId();
  const reviewData: Review = DefaultReview(deviceId, companyId, branchId, userId);  
  const {showSuccess, showError} = useToast();
  const {showLoader, hideLoader} = useLoader();
  const { data: companyData, isLoading } = useGetCompanyByIdQuery(companyId);

  const handleReviewSubmit = async (
    values: Review
  ) => {
    if (!branchId) return;

    try {
      showLoader();
      await upsertReview(values).unwrap();
      showSuccess('Your feedback is submitted successfully.');
      
    } catch (error: any) {
      console.error("Error submitting review:", error);
      showError('Error occured while sending your feedback');
    } finally {
      hideLoader();
    }
  };

  if(!companyData || isLoading) {
    return <LoadingIndicator message="Loading review form..." />;
  }

  return (
    <EmployeeReview
      userId={userId}
      employeeName={employeeName}
      employeeImage={employeeImage}
      onReviewSubmit={handleReviewSubmit}
      initialValues={reviewData}
      company={companyData}
      openDialog={openDialog}
      onDialogClose={onDialogClose}
    />
  );
};

